export const getErrorMessage = (errors) =>
  errors
    ? errors.map((error) => error.detail)
    : "There was an unexpected error, please try again later or contact the administrator";

export const MISSING_PO_NUMBER = "Purchase Order Number is required";
export const MISSING_SHIP_DATE = "Ship Date is required";
export const MISSING_BILLING_ADDRESS = "Billing Address is required";
export const MISSING_SHIPPING_ADDRESS = "Shipping Address is required";
